import React from 'react';
import { Helmet } from 'react-helmet';
import { PLATFORM } from '../config/platform';

export default function Seo({
  title,
  description,
  path = '/',
  image = '/assets/pool4real-app-icon.png',
  robots = 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1',
  schema = [],
}) {
  const canonical = `${PLATFORM.siteUrl}${path === '/' ? '' : path}`;
  const imageUrl = image.startsWith('http') ? image : `${PLATFORM.siteUrl}${image}`;
  const schemas = Array.isArray(schema) ? schema : [schema];
  const googleVerification = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION;

  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="application-name" content={PLATFORM.name} />
      <meta name="apple-mobile-web-app-title" content={PLATFORM.shortName} />
      <meta name="theme-color" content="#080b12" />
      {googleVerification && <meta name="google-site-verification" content={googleVerification} />}
      <meta name="robots" content={robots} />
      <meta name="googlebot" content={robots} />
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="en" href={canonical} />
      <link rel="alternate" hrefLang="x-default" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:site_name" content={PLATFORM.name} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:alt" content="Pool 4 Real social network and match tools for real-world pool and billiards players" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:alt" content="Pool 4 Real for real-world pool and billiards players" />
      <meta name="apple-itunes-app" content={`app-id=${PLATFORM.ios.appId}, app-argument=${canonical}`} />
      {schemas.filter(Boolean).map((item, index) => (
        <script type="application/ld+json" key={index}>{JSON.stringify(item)}</script>
      ))}
    </Helmet>
  );
}
